// extracted by mini-css-extract-plugin
export default {"answer":"Question_answer__yMW97","answer__correct":"Question_answer__correct__K7rF7","answer__wrong":"Question_answer__wrong__Dya3r"};